import { render } from "./LivrateurTuto.vue?vue&type=template&id=69dcf9f6&scoped=true"
import script from "./LivrateurTuto.vue?vue&type=script&lang=js"
export * from "./LivrateurTuto.vue?vue&type=script&lang=js"

import "./LivrateurTuto.vue?vue&type=style&index=0&id=69dcf9f6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69dcf9f6"]])

export default __exports__